import { Grid } from "@mui/material";
import { useResponsive } from "../../../../../src/Modulo_Responsive/Hooks/useResponsive";
import posts from "../../../../Data/post.json";
import Tarjeta_Blog from "../../Tarjetas/Tarjeta_Blog";

const Lista = ({ ids }) => {
    const { sCell } = useResponsive();

    const blogsOnly = posts.filter(
        (post) => post.tipo === "blog" && ids.includes(String(post.id))
    );

    return (
        <Grid
            container
            justifyContent="flex-start"
            alignItems="stretch"
            size={{ xs: 12, sm: 12, md: 12 }}
            spacing={4}
        >
            {blogsOnly.map((post, index) => (
                <Grid
                    container
                    key={index}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                    size={{ xs: 12, sm: 6, md: 6, lg: 4 }}
                >
                    <Tarjeta_Blog
                        imagen={post.imagen}
                        titulo={post.titulo}
                        descripcion={post.descripcion}
                        link={post.slug}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default Lista;